
import OBase from './OBase';
import * as Geometry from '../geometry';

export default class UnitX extends OBase {
  update () {
    let factorValTree = this.getFloatInput('Factor', false);
    let output = this.getGenericObjectOutput('Unit vector');

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < factorValTree.branches.length; i++) {
      for (let j = 0; j < factorValTree.branches[i].length; j++) {
        var path = factorValTree.paths[i];
        var v = factorValTree.branches[i][j];
        outTree.add(new THREE.Vector3(v, 0, 0), path);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/UnitX.js